var React = require('react');

function NextArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_84","data-name":"Path 84","d":"M355.056,2508l11,11-11,11","transform":"translate(-353.995 -2506.939)","fill":"none","stroke":"#e65300","strokeMiterlimit":"10","strokeWidth":"3","fillRule":"evenodd"}));
}

NextArrow.defaultProps = {"width":"14.182","height":"24.121","viewBox":"0 0 14.182 24.121"};

module.exports = NextArrow;

NextArrow.default = NextArrow;
